import React from 'react'
import { Radio } from 'semantic-ui-react'

const RadioToggle = (props) => <Radio onClick={props.onClick} toggle checked={props.isChk}/>

export default RadioToggle